<div class="ms-1 pt-1 pt-lg-0" >
    <a href="javascript:void(0);" (click)="helpersService.goToHomeLang()" class="ls-p-extra-small underlined"
        [ngClass]=" {
            'text-brand-10': isSecondLevelUp,
            'text-neutral-A1': !isSecondLevelUp
        }">
        Home 
    </a>
    <span [ngClass]=" {
        'text-brand-10': isSecondLevelUp,
        'text-neutral-A1': !isSecondLevelUp
    }" class="ls-p-extra-small"> / </span>
    <ng-contaniner *ngFor="let voice of itemBreadcrumb; let i = index" >
        <a *ngIf="voice.link != ''" [ngClass]="{
            'underlined' : i !== (itemBreadcrumb.length - 1),
            'text-neutral-A1': i !== (itemBreadcrumb.length - 1) && !isSecondLevelUp,
            'text-neutral-80': i === (itemBreadcrumb.length - 1) && !isSecondLevelUp,
            'text-brand-10': i !== (itemBreadcrumb.length - 1) && isSecondLevelUp,
            'text-neutral-50': i === (itemBreadcrumb.length - 1) && isSecondLevelUp
        }"
            class="ls-p-extra-small"
            [routerLink]="navigationService.splitUrlRouterLink(voice.url ? voice.url : voice.link).path" 
            [queryParams]="navigationService.splitUrlRouterLink(voice.url ? voice.url : voice.link).queryParams"
            [innerHTML]="voice.label">
        </a>
        <span *ngIf="i < (itemBreadcrumb.length-1) && voice.link != ''" 
            [ngClass]=" {
                'text-brand-10': isSecondLevelUp,
                'text-neutral-A1': !isSecondLevelUp
            }" class="ls-p-extra-small"> 
            / 
        </span>
    </ng-contaniner>
    <ng-contaniner *ngIf="title">
        <span class="ls-p-extra-small text-neutral-50" 
            [ngClass]="{
                'text-neutral-50': isSecondLevelUp,
                'text-neutral-A1': !isSecondLevelUp
            }"
            [innerHTML]="title">
        </span>
    </ng-contaniner>
</div>